// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__HBlo8","requiredAsterisk":"Info_requiredAsterisk__1Dt90"};